import Content from "./Content/Content";
import Approval from "./Approval/Approval";
import EditContent from "./EditContent";
import AddContent from "./AddContent";

const TeacherResourceCenter = {
  AddContent,
  Approval,
  EditContent,
  Content,
};

export default TeacherResourceCenter;
